import APIController from '../core-api-controller';

export const fetchSubscriptions = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/subscriptions${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const rescheduleNextSubscriptionApi = ({ subId = '', data = {} }) => {
  const path = `${APIController.endpointApi}/shopify/subscriptions/${subId}/reschedule_billings`;
  return APIController.postCallback(path, data);
};

export const updatePaymentMethodSubscriptionApi = ({ subId = '', data = {} }) => {
  const path = `${APIController.endpointApi}/shopify/subscriptions/${subId}/update_payment_method`;
  return APIController.postCallback(path, data);
};
